import { forwardRef, type Ref, type SVGProps } from "react";
const IconHospitalOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M13 23a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v4h-4v-4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M30 16c0 7.732-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2s14 6.268 14 14m-2 0c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHospitalOutlineSVG);
ForwardRef.displayName = "IconHospitalOutline";
export { ForwardRef as IconHospitalOutline };
